// base
import { createAsyncThunk } from '@reduxjs/toolkit';

// api
import { authApi } from '../apis/auth.api';

// action
import { actions } from '../actions/auth.action';

// service
import {
  COOKIE_ACCESS_TOKEN,
  COOKIE_REFRESH_TOKEN,
  COOKIE_SAVE_USER_ID,
  cookieStorage
} from 'services/cookie';

// modules
import { userApi } from 'modules/user/apis/user.api';

/**
 * SMS 모바일+국가 변경 문자발송
 */
export const getSmsChangeMobile = createAsyncThunk(
  actions.getSmsChangeMobileAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.getSmsChawwngeMobile(data);

      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * SMS 문자발송
 */
export const getSms = createAsyncThunk(
  actions.getSmsAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.getSms(data);

      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * SMS 검증
 */
export const getSmsVerify = createAsyncThunk(
  actions.getSmsVerifyAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.getSmsVerify(data);

      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * SMS 검증  Pwd 변경
 */
export const getSmsVerifyForgot = createAsyncThunk(
  actions.getSmsVerifyForgotAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.getSmsVerifyForgot(data);

      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 로그인
 */
export const userLogin = createAsyncThunk(
  actions.userLoginAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      cookieStorage.removeCookie(COOKIE_ACCESS_TOKEN);
      cookieStorage.removeCookie(COOKIE_REFRESH_TOKEN);

      const res = await authApi.postSignIn(data);

      const { ACCESS_TOKEN, REFRESH_TOKEN, userId, temporaryPasswdStatus } = res;

      if (!ACCESS_TOKEN) {
        // toast('Available after administrator sign-up approval.');
        return;
      }

      cookieStorage.setCookie(COOKIE_ACCESS_TOKEN, ACCESS_TOKEN);
      cookieStorage.setCookie(COOKIE_REFRESH_TOKEN, REFRESH_TOKEN);

      // FCM Token 발급

      const user = await userApi.getUsersId(userId);

      // if (import.meta.env.VITE_BUILD_MODE === 'prod') {
      //   const userAgent = window.navigator.userAgent;
      //   const isChromeBrowser = userAgent.includes('Chrome');

      //   if (user.isSuccess && isChromeBrowser) {
      //     const alarmToken = await requestPermission();

      //     const isMobile = /iPhone|iPad|iPod|Android/i.test(
      //       navigator.userAgent
      //     ); // 안드로이드 아이폰을 검사해 체크
      //     let deviceType = '';

      //     deviceType = isMobile ? 'MO' : 'PC';

      //     if (alarmToken) {
      //       const responsePostAlarmToken = await cctvApi.postAlarmToken({
      //         userId: user.resultObject.userId,
      //         alarmToken: alarmToken,
      //         deviceType: deviceType
      //       });

      //       if (!responsePostAlarmToken?.isSuccess) {
      //         throw new Error(
      //           `Failed to Post the alarm token for fcm, ${responsePostAlarmToken.code}`
      //         );
      //       }
      //     } else {
      //       throw new Error(`Failed to Get the alarm token for fcm`);
      //     }
      //   }
      // }

      return fulfillWithValue({
        ...res,
        isLogin: true,
        userInfo: {
          ...user.resultObject,
          thumnails: undefined,
          accountType: user.resultObject.role.replace('ROLE_', '')
        },
        temporaryPasswdStatus,
        userId
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 로그아웃
 */
export const userLogout = createAsyncThunk(actions.userLogoutAction, (_, { rejectWithValue }) => {
  try {
    // save Id 저장 위해 임시 주석
    // clearUserToken();

    cookieStorage.removeCookie(COOKIE_ACCESS_TOKEN);
    cookieStorage.removeCookie(COOKIE_REFRESH_TOKEN);

    return {
      userInfo: null
    };
  } catch (error) {
    return rejectWithValue(error);
  }
});

/**
 * 회원가입
 */
export const userSignUp = createAsyncThunk(
  actions.userSignUpAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.fetchSignUp(data);

      if (!res) return;

      return fulfillWithValue(res.data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 비밀번호 변경
 */
export const postPassword = createAsyncThunk(
  actions.postPasswordAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.postPassword(data);

      if (!res) return;

      return fulfillWithValue(res.data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 관리자 승인 대기 리스트 조회
 */
export const getAuthList = createAsyncThunk(
  actions.authListAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.getAuth(data);

      if (!res) return;
      const { code, isSuccess, message, resultList, resultObject, totalMap } = res;

      return fulfillWithValue({
        code,
        isSuccess,
        message,
        resultList,
        resultObject,
        totalMap
      });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 관리자 승인 (개별,단체)
 */
export const postApproval = createAsyncThunk(
  actions.postApproveAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.postApproval(data);

      if (!res) return;

      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 관리자 승인 거절 (개별,단체)
 */
export const postReject = createAsyncThunk(
  actions.postRejectAction,
  async (data, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await authApi.postReject(data);

      if (!res) return;

      return fulfillWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

/**
 * 엑세스 토큰 재발급
 */
export const getAccessToken = createAsyncThunk(
  actions.getAccessTokenAction,
  async (_, { rejectWithValue }) => {
    try {
      const accessToken = await authApi.getRefreshToken();

      if (accessToken) {
        cookieStorage.setCookie(COOKIE_ACCESS_TOKEN, accessToken);

        return true;
      } else {
        cookieStorage.removeCookie(COOKIE_REFRESH_TOKEN);
        cookieStorage.removeCookie(COOKIE_SAVE_USER_ID);

        return false;
      }
    } catch (error) {
      cookieStorage.removeCookie(COOKIE_REFRESH_TOKEN);
      cookieStorage.removeCookie(COOKIE_SAVE_USER_ID);

      return rejectWithValue(error);
    }
  }
);
